import * as types from "../types";

export const pageAction = (pageTitle) =>  {
    return {
        type: types.SET_PAGE_TITLE,
        payload: pageTitle,
    }
}